<template>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Jantina'" >
        <GChart :type="type_pie" :data="jantina_datas"   :options="pie_options"  v-if="jantina_datas.length > 0"/>
      </z-page>
    </div>
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Betina'" >
        <GChart :type="type_pie" :data="betina_datas"   :options="pie_options"  v-if="betina_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka Ternakan'" >
        <GChart :type="type_pie" :data="baka_ternakan_datas"   :options="pie_options"  v-if="baka_ternakan_datas.length > 0"/>
      </z-page>
    </div>
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Vaksin'" >
        <GChart :type="type_pie" :data="vaksin_datas"   :options="pie_options"  v-if="vaksin_datas.length > 0"/>
      </z-page>
    </div>
  </div>
  <div class="w-flex wrap smd-column" >
    <div class="grow " >
      <z-page class="white--bg mt3 sh2" :title="'Baka Jantina'" >
        <GChart :type="type_column" :data="baka_jantina_datas"   :options="column_options"  v-if="baka_jantina_datas.length > 0"/>
      </z-page>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  name: "Peternak",
  components: {
        GChart
  },
  data() {
    return {
      loading: false,
      type_pie: "PieChart",
      type_column: "ColumnChart", 
      pie_options: {
          height: 200,
      },
      column_options: {
          height: 500,
      },
      jantina_datas: [],
      betina_datas: [],
      baka_ternakan_datas: [],
      baka_jantina_datas: [],
      vaksin_datas: [],
    }
  },
  methods:{
    getJantina(){
      this.$zcomm.get(this.api_service + 'dashboard/peternak_jantina', {}).then(res => {
        this.jantina_datas = res
      })
    },
    getBetina(){
      this.$zcomm.get(this.api_service + 'dashboard/peternak_betina', {}).then(res => {
        this.betina_datas = res
      })
    },
    getBakaTernakan(){
      this.$zcomm.get(this.api_service + 'dashboard/peternak_baka_ternakan', {}).then(res => {
        this.baka_ternakan_datas = res
      })
    },
    getBakaJantina(){
      this.$zcomm.get(this.api_service + 'dashboard/peternak_baka_jantina', {}).then(res => {
        this.baka_jantina_datas = res
      })
    },
    getVaksin(){
      this.$zcomm.get(this.api_service + 'dashboard/peternak_vaksin', {}).then(res => {
        this.vaksin_datas = res
      })
    },
  },
      
  mounted() {
    this.getJantina()
    this.getBetina()
    this.getBakaTernakan()
    this.getBakaJantina()
    this.getVaksin()
  }
}
      

</script>  
